import { NoNwTableProps } from '../../../../../@types/kr/types';
import { useTheme } from '../../../../../providers/theme';
import { getColors } from '../../../../utils/getColors';
import KrTable from './table';
import { Checkbox, ConfigProvider } from 'antd';

const NoNwTable = (props: NoNwTableProps) => {
  const { isDay } = useTheme();
  const colors = getColors(isDay);
  const formatDisplayValue = (value: number | null) => {
    if (value == null) {
      return '-';
    }
    return value.toFixed(3);
  };

  const handleToggleDisplay = (key: number, checked: boolean) => {
    const updatedValues = props.values.map((item, index) =>
      index === key ? { ...item, display: checked } : item
    );
    const updatedSw = props.sw.map((item, index) =>
      index === key ? { ...item, display: checked } : item
    );

    props.setSw(prev => ({
      ...prev,
      [props.type]: updatedSw
    }));
    props.setValues(updatedValues);
  };

  const tableColumns = [
    {
      title: 'Sw',
      dataIndex: 'sw',
      key: 'sw',
      render: (_, record, index) => {
        const value = props.sw[index]?.value ?? null;
        const display = props.sw[index]?.display;

        if (!display) {
          return (
            <span style={{ color: 'gray', textDecoration: 'line-through' }}>
              {formatDisplayValue(value)}
            </span>
          );
        }
        return <span>{formatDisplayValue(value)}</span>;
      }
    },
    {
      title: props.type === 'no_w' ? 'No' : 'Nw',
      dataIndex: props.type === 'no_w' ? 'no' : 'nw',
      key: props.type === 'no_w' ? 'no' : 'nw',
      render: (_, record, index) => {
        const value = props.values[index]?.value ?? null;
        const display = props.values[index]?.display;

        if (!display) {
          return (
            <span style={{ color: 'gray', textDecoration: 'line-through' }}>
              {formatDisplayValue(value)}
            </span>
          );
        }
        return <span>{formatDisplayValue(value)}</span>;
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record, index) => {
        const display = props.values[index]?.display;

        return (
          <Checkbox
            checked={display}
            onChange={e => handleToggleDisplay(index, e.target.checked)}
          />
        );
      }
    }
  ];

  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: colors.colorPrimary2,
            colorText: colors.text,

            colorBgContainer: 'transparent',
            colorBorder: colors.colorPrimary2
          },
          components: {
            Checkbox: {
              colorTextDisabled: 'gray',
              colorText: colors.text
            }
          }
        }}
      >
        <KrTable columns={tableColumns} data={props.tableData} bordered />
      </ConfigProvider>
    </div>
  );
};

export default NoNwTable;
